import { KnowledgeFile, Tag, Category, FileType } from '../types';

export const mockTags: Tag[] = [
  { id: '123e4567-e89b-12d3-a456-426614174001', name: 'Important', color: '#ef4444' },
  { id: '123e4567-e89b-12d3-a456-426614174002', name: 'Reference', color: '#3b82f6' },
  { id: '123e4567-e89b-12d3-a456-426614174003', name: 'Project A', color: '#10b981' },
  { id: '123e4567-e89b-12d3-a456-426614174004', name: 'Tutorial', color: '#f59e0b' },
  { id: '123e4567-e89b-12d3-a456-426614174005', name: 'Archive', color: '#6b7280' },
  { id: '123e4567-e89b-12d3-a456-426614174006', name: 'Marketing', color: '#8b5cf6' },
  { id: '123e4567-e89b-12d3-a456-426614174007', name: 'Finance', color: '#14b8a6' },
  { id: '123e4567-e89b-12d3-a456-426614174008', name: 'HR', color: '#ec4899' },
];

export const mockUsers = [
  { id: '123e4567-e89b-12d3-a456-426614174011', name: 'John Doe', avatar: 'https://i.pravatar.cc/150?u=1' },
  { id: '123e4567-e89b-12d3-a456-426614174012', name: 'Jane Smith', avatar: 'https://i.pravatar.cc/150?u=2' },
  { id: '123e4567-e89b-12d3-a456-426614174013', name: 'Alex Johnson', avatar: 'https://i.pravatar.cc/150?u=3' },
];

const generateMockFile = (
  id: string,
  name: string,
  type: FileType,
  tags: Tag[],
  size: number,
  starred = false
): KnowledgeFile => {
  const createdAt = new Date(Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000).toISOString();
  const updatedAt = new Date(Date.now() - Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000).toISOString();
  
  return {
    id,
    name,
    type,
    tags,
    size,
    createdAt,
    updatedAt,
    createdBy: mockUsers[Math.floor(Math.random() * mockUsers.length)].id,
    updatedBy: mockUsers[Math.floor(Math.random() * mockUsers.length)].id,
    path: `/files/${id}`,
    starred,
    description: `This is a ${type} file for demonstration purposes.`,
  };
};

export const mockFiles: KnowledgeFile[] = [
  generateMockFile('123e4567-e89b-12d3-a456-426614174101', 'Annual Report 2023.pdf', 'pdf', [mockTags[0], mockTags[6]], 2560000, true),
  generateMockFile('123e4567-e89b-12d3-a456-426614174102', 'Project Roadmap.docx', 'document', [mockTags[2], mockTags[1]], 1280000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174103', 'Team Photo.jpg', 'image', [mockTags[4]], 3500000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174104', 'Product Demo.mp4', 'video', [mockTags[3], mockTags[5]], 15000000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174105', 'Sales Forecast.xlsx', 'spreadsheet', [mockTags[6]], 980000, true),
  generateMockFile('123e4567-e89b-12d3-a456-426614174106', 'Company Handbook.pdf', 'pdf', [mockTags[7], mockTags[1]], 4200000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174107', 'Marketing Presentation.pptx', 'presentation', [mockTags[5]], 5800000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174108', 'Research Data.xlsx', 'spreadsheet', [mockTags[2], mockTags[4]], 1850000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174109', 'User Guide.pdf', 'pdf', [mockTags[3], mockTags[1]], 3200000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174110', 'Website Mockup.png', 'image', [mockTags[5]], 2900000, true),
  generateMockFile('123e4567-e89b-12d3-a456-426614174111', 'API Documentation.md', 'document', [mockTags[1], mockTags[3]], 750000),
  generateMockFile('123e4567-e89b-12d3-a456-426614174112', 'Budget 2023.xlsx', 'spreadsheet', [mockTags[6], mockTags[0]], 1250000),
];

export const mockCategories: Category[] = [
  {
    id: '123e4567-e89b-12d3-a456-426614174201',
    name: 'Documents',
    children: [
      {
        id: '123e4567-e89b-12d3-a456-426614174202',
        name: 'Reports',
        parentId: '123e4567-e89b-12d3-a456-426614174201',
        files: [mockFiles[0], mockFiles[8]]
      },
      {
        id: '123e4567-e89b-12d3-a456-426614174203',
        name: 'Guides',
        parentId: '123e4567-e89b-12d3-a456-426614174201',
        files: [mockFiles[5], mockFiles[8]]
      }
    ]
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174204',
    name: 'Projects',
    children: [
      {
        id: '123e4567-e89b-12d3-a456-426614174205',
        name: 'Project A',
        parentId: '123e4567-e89b-12d3-a456-426614174204',
        files: [mockFiles[1], mockFiles[7]]
      },
      {
        id: '123e4567-e89b-12d3-a456-426614174206',
        name: 'Project B',
        parentId: '123e4567-e89b-12d3-a456-426614174204',
        children: [
          {
            id: '123e4567-e89b-12d3-a456-426614174207',
            name: 'Development',
            parentId: '123e4567-e89b-12d3-a456-426614174206',
            files: [mockFiles[10]]
          },
          {
            id: '123e4567-e89b-12d3-a456-426614174208',
            name: 'Marketing',
            parentId: '123e4567-e89b-12d3-a456-426614174206',
            files: [mockFiles[6], mockFiles[9]]
          }
        ]
      }
    ]
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174209',
    name: 'Media',
    children: [
      {
        id: '123e4567-e89b-12d3-a456-426614174210',
        name: 'Images',
        parentId: '123e4567-e89b-12d3-a456-426614174209',
        files: [mockFiles[2], mockFiles[9]]
      },
      {
        id: '123e4567-e89b-12d3-a456-426614174211',
        name: 'Videos',
        parentId: '123e4567-e89b-12d3-a456-426614174209',
        files: [mockFiles[3]]
      }
    ]
  },
  {
    id: '123e4567-e89b-12d3-a456-426614174212',
    name: 'Finance',
    files: [mockFiles[4], mockFiles[11]]
  }
];